// TumHaberler.tsx
import React, { useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import ListGrid from "components/yenimahalle/ListGrid";
import PortalApi from "api/PortalApi";
import { m } from "framer-motion";
import { NewsList } from "models/Response/Portal";
import { dateFormatter } from "utils/dateFormatter";
import { useNavigate } from "react-router-dom";
import { slugify } from "utils/slugify";
// import PortalPeopleApi from "../../api/PortalPeopleApi"; // Uncomment if you want to use a real API

// Define an interface for the news items
interface NewsItem {
  id: number;
  title: string;
  date: string;
  description?: string;
  image?: string;
}

const TumHaberler: React.FC = () => {
  const [newsItems, setNewsItems] = useState<NewsItem[]>([]);
  const navigate = useNavigate();

  // Array of Turkish month names
  const months = [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık",
  ];

  /**
   * fetchNews simulates the process of sending an API request.
   * In a real-world scenario, you would replace this with an actual API call.
   * @param month - The selected month (in Turkish)
   * @param year - The selected year (as a string)
   */
  const fetchNews = async (month: string, year: string) => {
    const monthIndex = months.indexOf(month);
    const response = await PortalApi.getNewsByDate(
      parseInt(year),
      monthIndex + 1
    );
    if (response && response.content.newsList) {
      const mappedItems = response.content.newsList.map((item: NewsList) => ({
        id: item.newsId,
        title: item.title,
        date: dateFormatter(item.newsDate, false),
      }));
      setNewsItems(mappedItems);
    }
  };

  useEffect(() => {
    // API'den meclis üyeleri verisini çekiyoruz
    const fetchData = async () => {};

    fetchData();
  }, []);

  /**
   * Callback function to handle date filter changes from ListGrid.
   * @param month - The newly selected month
   * @param year - The newly selected year
   */
  const handleFilterChange = (month: string, year: string) => {
    console.log("Filter changed:", month, year);
    fetchNews(month, year);
  };

  // On component mount, determine the current month and year and fetch the data.
  useEffect(() => {
    const currentDate = new Date();
    const currentMonth = months[currentDate.getMonth()]; // getMonth returns 0-based index
    const currentYear = currentDate.getFullYear().toString();
    fetchNews(currentMonth, currentYear);
  }, []);

  const handleCardClick = (item: NewsItem & { id: number }) => {
    const url = `/HaberDetay/${slugify(item.title)}/${item.id}`;
    navigate(url);
  };
  return (
    <Layout>
      <BasicHeader
        headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe"
        headingLine2=""
      />
      <ListGrid
        items={newsItems}
        showDateFilter={true}
        onFilterChange={handleFilterChange}
        onItemClick={handleCardClick}
      />
    </Layout>
  );
};

export default TumHaberler;
